<div class="icon-container">
  <img [src]="data()?.iconUrl" alt="" />
</div>

@if (showFilename()) {
  <div class="name">
    {{ name() }}
  </div>
}

@if (showSizeAndDownload()) {
  <div class="info">
    <div class="size">
      {{ versionSize() | dataUnitsBigInt }}
    </div>

    @if (allowDownload()) {
      <span>・</span>

      <app-asset-download-button
        location="asset-header"
        [asset]="asset()"
        [gallery]="gallery()"
        [galleryPermissions]="galleryPermissions()"
      >
        Download
      </app-asset-download-button>
    }
  </div>
}
